import css from '@styled-system/css';
import variant from '@styled-system/variant';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('ContentContainer')(({ center }) => css({
    minHeight: [null, null, '122px'],
    paddingTop: ['m', 'm', 'default'],
    paddingBottom: 'zero',
    paddingX: ['zero', 'zero', 'm'],
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    flexWrap: [null, null, 'wrap'],
    justifyContent: center && [null, null, 'center'],
    gap: 'm',
}));
themeStyles.addBaseStyles('PaymentInfo')(css({
    '& > *:last-child': {
        marginBottom: 'zero',
    },
}));
themeStyles.addBaseStyles('Title')(({ alignItems = 'center' }) => css({
    textTransform: 'capitalize',
    display: 'flex',
    width: ['72px', '72px', 'auto'],
    alignItems,
    gap: 'xxs',
    flex: ['1', '1', 'unset'],
}));
themeStyles.addBaseStyles('NumberText')(css({
    display: 'flex',
    fontFamily: 'bold',
    fontSize: ['18px', '28px'],
    lineHeight: ['22px', '28px'],
    flex: ['1', '1', 'unset'],
}));
themeStyles.addBaseStyles('PaymentAmountContainer')(css({
    display: 'flex',
    flexDirection: ['row', 'row', 'column'],
    alignItems: 'flex-start',
    gap: ['l', 'l', 'xxs'],
    marginBottom: ['s', 's', 'zero'],
}));
themeStyles.addBaseStyles('PaymentFrequencyContainer')(css({
    display: 'flex',
    flexDirection: ['row', 'row', 'column'],
    alignItems: 'flex-start',
    gap: ['l', 'l', 'xxs'],
    marginBottom: ['m', 'm', 'zero'],
}));
themeStyles.addBaseStyles('TermInfo')(css({
    display: 'flex',
    gap: 'xs',
    alignItems: 'baseline',
    flex: ['1', '1', 'unset'],
}));
themeStyles.addBaseStyles('AvailableOfferContainer')(css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'xxs',
}), ({ theme, }) => variant({
    prop: 'displayMode',
    variants: {
        row: {
            paddingTop: 'm',
            paddingX: [null, null, 'xl'],
            borderTop: `${theme.borders[1]}`,
            borderTopColor: 'grey.2',
            flex: [null, null, '0 1 100%'],
        },
        column: {
            borderLeft: `${theme.borders[1]}`,
            borderLeftColor: 'grey.2',
            paddingLeft: 'm',
        },
    },
}));
themeStyles.addBaseStyles('AvailableOfferTitle')(css({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'xxs',
}));
themeStyles.addBaseStyles('OfferWrapper')(css({
    display: 'flex',
    gap: 'xs',
    alignItems: 'baseline',
}));
themeStyles.addBaseStyles('CashRebateContainer')(css({
    display: 'flex',
    flexDirection: ['row', 'row', 'column'],
    alignItems: 'flex-start',
    gap: ['14px', '14px', 'xxs'],
}));
themeStyles.addBaseStyles('RebateAmountContainer')(css({
    display: 'flex',
    gap: 'xs',
    alignItems: 'baseline',
}));
themeStyles.addBaseStyles('StyledPaymentFreqTooltip')(css({
    display: 'flex',
    alignItems: 'start',
}));
themeStyles.addBaseStyles('PaymentLoaderWrapper')(({ width }) => css({
    width: width !== null && width !== void 0 ? width : ['100%', '100%', '40%'],
    display: 'flex',
    justifyContent: 'center',
}));
export default themeStyles;
